import { createFormContext, zodResolver } from '@mantine/form'
import { useDebouncedCallback } from '@mantine/hooks'
import { useEffect, type HTMLAttributes } from 'react'

import { useOnboardingForm } from '../../hooks/useOnboardingForm'
import { type OnboardingFormData } from '../../types/OnboardingFormData'
import { Step01 } from './Step01'
import { Step02 } from './Step02'
import { Step03 } from './Step03'
import { StepReview } from './StepReview'
import { StepSubmit } from './StepSubmit'

export const [FormProvider, useFormContext, useForm] =
  createFormContext<OnboardingFormData>()

type FormOnboardingProps = HTMLAttributes<HTMLFormElement>

export function FormOnboarding({ ...props }: FormOnboardingProps) {
  const { schema, initialValues } = useOnboardingForm()
  const setFormValuesOnLocalStorage = useDebouncedCallback((values) => {
    localStorage.setItem('form_onboarding', JSON.stringify(values))
  }, 500)

  const form = useForm({
    initialValues,
    validate: zodResolver(schema),
    onValuesChange: setFormValuesOnLocalStorage,
  })

  useEffect(() => {
    const storedValue = window.localStorage.getItem('form_onboarding')
    if (storedValue) {
      try {
        form.setValues(JSON.parse(storedValue))
      } catch (e) {
        console.log(`Failed to parse stored value: ${e}`)
      }
    }
  }, [])

  return (
    <FormProvider form={form}>
      <form {...props}>
        <Step01 />
        <Step02 />
        <Step03 />
        <StepReview />
        <StepSubmit />
      </form>
    </FormProvider>
  )
}
